import ApiService from './ApiService';

export default class ReferralCodeApi extends ApiService {
    constructor() {
        super('referral-codes');
    }

    getAllReferralCode(payload) {
        return this.get('', payload);
    }

    getReferralCodeDetail({ payload, id }) {
        return this.get(`${id}`, payload);
    }

    createReferralCode(payload) {
        return this.post('', payload);
    }

    getReferralCodeInfo(id) {
        return this.get(`info/${id}`);
    }

    deleteReferralCode(id) {
        return this.delete(`${id}`);
    }

    updateReferralCode({ id, payload }) {
        return this.put(`${id}`, payload);
    }

    changeStatusReferralCode({ id, payload }) {
        return this.put(`referral-codes-change-status/${id}`, payload);
    }
}
